package com.ilussobsa.views

import com.ilussobsa.Strings
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.pageNavigator
import com.lightningkite.kiteui.navigation.render
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.l2.icon
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*

data class BackButtonInfo(
    val needed: Reactive<Boolean>,
    val action: ()->Unit
)

fun ViewWriter.backButtonIfNeeded(backButtonInfo: BackButtonInfo?) {
    backButtonInfo?.let {
        button {
            ::shown { it.needed() }
            centered - icon(Icon.list, Strings.returnToList)
            onClick { it.action() }
        }
    }
}

inline fun <T> ViewWriter.psuedoRadioToggleButton(
    me: Reactive<T>,
    selected: MutableReactive<T>,
    crossinline open: suspend ()->Unit,
    crossinline setup: ViewWriter.()->Unit
): ViewModifiable {
    val immediateify = Signal(false)
    return button {
        dynamicTheme { if(immediateify()) SelectedSemantic else UnselectedSemantic }
        reactiveScope { immediateify.value = selected() == me() }
        setup()
        onClick {
            selected set me()
            open()
        }
    }
}

fun <T> ViewWriter.listDetailV2(
    selected: MutableReactive<T>,
    listSize: Dimension = 25.rem,
    detailSizeRequired: Dimension = 55.rem,
    list: ViewWriter.(open: suspend ()->Unit) -> ViewModifiable,
    detail: ReactiveContext.(T) -> Page
) = swapView {
    val useCollapsed = remember { WindowInfo.invoke().width < listSize + detailSizeRequired }
    swapping(
        current = { useCollapsed() },
        views = {
            if(it) {
                list {
                    pageNavigator.navigate(detail(selected()))
                }
            } else {
                row {
                    sizeConstraints(
                        width = listSize
                    ) - list {
                        if(useCollapsed()) {
                            pageNavigator.navigate(detail(selected()))
                        }
                    }
                    expanding - unpadded - swapView {
                        val screen = remember { selected().let { detail(it) } }
                        swapping(current = { screen() }, views = {
                            unpadded; it.render(this@swapping)
                        })
                    }
                }
            }
        }
    )
}